const checkout = {
  steps: {
    cart: 'Einzelheiten',
    customerData: 'Kundendaten',
    delivery: 'Lieferart',
    payment: 'Zahlung',
    overview: 'Überprüfen',
  },
  cart: {
    product: 'Artikel',
    emptyCart: 'Ihr Warenkorb ist leer',
    emptyCartDescription1: 'In Ihrem Warenkorb befinden sich noch keine Produkte. Entdecken Sie',
    emptyCartDescription2: 'unser Apotheken-Sortiment oder',
    redeemPrescription: 'lösen Sie Ihr (E-)Rezept ein',
    removeProduct: 'Sind sie sicher, dass Sie das Produkt aus Ihrem Warenkorb entfernen möchten?',
    myLife: {
      title: 'Kostenlos für Sie',
      description: 'Bitte legen Sie die aktuelle my life meiner Bestellung bei.',
    },
    prescriptionsTitle: 'Ihre (E-)Rezepte (XX)',
    prescriptionsSubtitle: 'Bitte legen Sie bei Produktübergabe Ihr Originalrezept vor. Erst dadurch wird der Kaufvertrag abgeschlossen.',
    productsTitle: 'Artikel (XX)',
    noPaymentOptions: 'Keine Online-Zahlung',
    carouselTitle: 'Aktuell beliebt',
    goToProductOverview: 'Zur Produktübersicht',
    removePrescriptions: '(E-)Rezepte leeren',
    removeProducts: 'Artikel leeren',
    removeAllModal: {
      prescriptionsTitle: '(E-)Rezepte leeren',
      prescriptionsDescription: 'Sind Sie sicher, dass Sie alle (E-)Rezepte aus Ihrem Warenkorb entfernen möchten? Der Warenkorb kann nicht wiederhergestellt werden.',
      productsTitle: 'Artikel leeren',
      productsDescription: 'Sind Sie sicher, dass Sie alle Produkte aus Ihrem Warenkorb entfernen möchten? Der Warenkorb kann nicht wiederhergestellt werden.',
      cancel: 'Abbrechen',
      confirm: 'Ja, ich bin sicher',
    },
  },
  pricing: {
    subtotal: 'Zwischensumme',
    delivery: 'Botendienst',
    coupon: 'Coupon',
    total: 'Gesamtsumme',
    vat: 'inkl. MwSt.',
    freeOfCharge: 'kostenlos',
    totalOfflineDelivery: 'Gesamtsumme Zahlung bei Übergabe',
    coPaymentPharmacyInfo: 'Zuzahlungs-Information für Rezepte erfolgt in der Apotheke',
    totalOnlinePayment: 'Gesamtsumme Online-Zahlung',
    totalTooltip: {
      title: 'Informationen zur Preisberechnung',
      section1: {
        title: 'Ihr Warenkorb enthält (E-)Rezepte',
        content: {
          1: `Bei Vorbestellungen, die ein Rezept enthalten, kann der Betrag für die Zuzahlung, sowie der durch den privat versicherten Patienten zu bezahlende Arzneimittelpreis,
      <strong> erst nach Abschluss der Vorbestellung durch den Apotheker</strong> ermittelt und mitgeteilt werden.`,
          2: 'Daher ist der hier ausgegebene Betrag in diesem Fall <strong>eine vorläufige Preisinformation.</strong>',
          3: 'Die anfallenden Kosten für Produkte mit Rezept <strong>kommen noch hinzu.</strong>',
        },
      },
      section2: {
        title: 'Ihr Warenkorb enthält (E-)Rezepte',
        content: 'Die <strong>Zuzahlung je Produkt</strong> beträgt bei gesetzlich Versicherten',
        list: {
          item1: 'Zuzahlungsbefreit: 0 €',
          item2: 'Zuzahlungspflichtig: Zwischen 5 und 10 €',
        },
      },
    },
    removeCoupon: 'Coupon entfernen',

  },
  cartOverview: {
    overview: 'Übersicht',
    couponCode: 'Coupon eingeben',
    redeem: 'Einlösen',
    toCheckout: 'Weiter zur Kasse',
  },
  customer: {
    successfulRegistration: `Sie haben sich erfolgreich registriert.
    Bitte verifizieren Sie nach Abschluss Ihrer Bestellung Ihr Kundenkonto, indem Sie auf den Link klicken, den wir Ihnen per E-Mail gesendet haben.`,
  },
  delivery: {
    deliveryWithCourierService: 'Lieferung mit Botendienst',
    deliveryByAgreementTitle: 'Botendienst nach Vereinbarung',
    deliveryByAgreementDescription: 'Ihre Apotheke wird sich nach der Bestellung mit Ihnen in Verbindung setzen.',
    deliveryByAgreementAdditionalCostsMessage: 'Ggf. kann es zu Zusatzkosten für die Botendienstlieferung kommen, die nicht in der Gesamtsumme enthalten sind.',
    expressDeliveryTitle: 'Express-Botendienstlieferung',
    expressDeliveryCosts: 'Expresskosten',
    expressDeliveryPeriodInfo: 'Innerhalb von [time] Minuten<sup>6</sup> nach Bestellbestätigung',
    homeDeliveryTitle: 'Botendienst mit Termin',
    homeDeliveryCosts: 'Botendienstkosten',
    nextPeriod: 'Nächster Termin',
    pickupTitle: 'Abholung in der Apotheke',
    pickupDescription: 'Die Apotheke informiert Sie per SMS, sobald die Bestellung abgeholt werden kann.',
    freeOfCharge: 'kostenfrei',
    newAddressPromise: '{strongText} Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
    newAddressPromiseTitle: 'Unser Versprechen:',
    newAddressForm: {
      chooseDeliveryAddress: 'Bitte wählen Sie Ihre Lieferadresse',
      addNew: 'Neue Adresse hinzufügen',
      company: 'Firma',
      additionalInfo: 'Bemerkung',
      street: 'Straße',
      houseNumber: 'Hausnummer',
      save: 'Speichern',
    },
    chooseDeliveryOption: 'Lieferoption wählen',
    chooseDeliveryTime: 'Bitte wählen Sie die gewünschte Lieferzeit',
    unsavedAddressMessage: 'Bitte speichern Sie Ihre Adresseingaben, damit die Lieferoptionen geprüft werden können.',
    unsavedAddressChangesMessage: 'Sie müssen Ihre Änderungen speichern, um fortfahren zu können.',
    zipCodesModal: {
      listOfExpressDeliveryZipCodes: 'Liste der für die Express-Lieferung verfügbaren PLZ',
      listOfExpressDeliveryZipCodesDescription: 'Die folgenden PLZ können vom Express-Botendienst dieser Apotheke beliefert werden',
      listOfHomeDeliveryZipCodes: 'Liste der für die Botendienstlieferung verfügbaren PLZ',
      listOfHomeDeliveryZipCodesDescription: 'Die folgenden PLZ können vom regulären Botendienst dieser Apotheke beliefert werden',
    },
  },
  payment: {
    paymentAtPharmacy: 'Zahlung in der Apotheke',
    paymentAtPharmacyDescription: 'Sie können bar oder mit einer anderen akzeptierten Zahlungsart Ihrer Apotheke zahlen.',
    paymentAtCourier: 'Zahlung beim Botendienst',
    paymentAtCourierDescription: 'Sie können bar oder mit einer anderen akzeptierten Zahlungsart des Botendienstes zahlen.',
    continueAsPreOrder: 'Weiter als Vorbestellung',
    paymentOnline: 'Direkt online zahlen',
    enterPaymentAddress: 'Bitte geben Sie Ihre Rechnungsadresse an',
    selectPaymentMethod: 'Bitte wählen Sie Ihre gewünschte Zahlungsart',
    sameAsDeliveryAddress: 'Identisch mit Lieferadresse',
    unsavedAddressChangesMessage: 'Sie müssen Ihre Änderungen speichern, um fortfahren zu können.',
    differentPaymentAddress: 'Abweichende Rechnungsadresse',
    newAddressAdded: 'Neue Adresse erfolgreich hinzugefügt.',
  },
  overview: {
    overviewDescription: 'Bitte überprüfen Sie Ihre Angaben erneut.',
    expressDeliveryDescription: 'Ihre Bestellung wird innerhalb von {time} Min. nach Bestellbestätigung der Apotheke geliefert.',
    pickupAlertText: 'Doppelte Wege sparen: Ihre Apotheke informiert Sie, sobald Ihre Bestellung zur Abholung für Sie bereit liegt.',
    paymentMethod: 'Zahlart',
    whatsApp: {
      title: 'WhatsApp Beratung',
      agreement: 'WhatsApp Kommunikation zustimmen',
      hint: 'Ihre Zustimmung können Sie jederzeit widerrufen.',
    },
    deliveryAddress: 'Lieferadresse',
    paymentAddress: 'Rechnungsadresse',
    dearMan: 'Lieber',
    dearWoman: 'Liebe',
    hello: 'Hallo',
    onlinePayment: 'Online-Zahlung',
    paymentWithCourier: 'Zahlung beim Botendienst',
    prescriptionMessage: 'Über die Höhe der Zuzahlungen informiert Sie Ihre Apotheke.',
    form: {
      consent: 'Ich bin damit einverstanden, dass meine Bestelldaten an die ausgewählte Apotheke weitergegeben werden. Ich kann mein Einverständnis bis zur Abwicklung der Vorbestellung widerrufen.',
      newsletter: 'Melden Sie sich hiermit für unseren kostenfreien Newsletter an und profitieren Sie von regelmäßigen Produktempfehlungen und Neuigkeiten rund um Ihre Apotheke.',
    },
    payPalRedirect: 'Sie werden weitergeleitet zu',
    freeMyLifeInsert: 'Kostenlose Beilage des my life Magazins',
    preOrder: 'Vorbestellung',
    feePreOrder: 'Kostenpflichtig Vorbestellung',
  },
  thankYou: {
    message: {
      title: 'Vielen Dank für Ihre Bestellung in\nder {pharmacyName}',
      orderNumber: 'Bestellnummer',
      preOrderNumber: 'Vorbestellnummer',
      toOverview: 'Zur Bestellübersicht',
      toStartPage: 'Zur Startseite',
      continueShopping: 'Weiter einkaufen',
    },
    orderError: {
      title: 'Ihre Bestellung konnte nicht abgeschlossen werden',
      subtitle: 'Bitte versuchen Sie es erneut.',
    },
    whatsApp: {
      title: 'Haben Sie noch Fragen oder wünschen Sie eine Beratung?',
      subtitle: 'Dann kontaktieren Sie gerne Ihre Apotheke via WhatsApp.',
      buttonText: 'WhatsApp',
    },
    bullets: {
      emailWithDetails: 'Sie erhalten zeitnah eine E-Mail mit Ihren Bestell-Details.',
      orderStatus: 'Ihre Apotheke hält Sie über den Status Ihrer Bestellung per E-Mail und SMS auf dem Laufenden.',
      pickUp: 'Sie können Ihre Bestellung in der Apotheke abholen.',
      deliveryTime: 'Ihre Bestellung wird geliefert am {deliveryTime}.',
      deliveryByAgreement: 'Ihre Apotheke wird sich nach der Bestellung mit Ihnen in Verbindung setzen.',
      expressDeliveryTime: 'Ihre Bestellung wird innerhalb von {minutes} Minuten nach Bestellbestätigung der Apotheke geliefert.',
      alert: 'Bitte legen Sie bei Bestellübergabe Ihr Originalrezept vor.',
    },
    appBlock: {
      title: 'Installieren Sie auch unsere App',
      bullet1: 'Mit zusätzlichen Services für unsere Kunden mit regelmäßigem Bedarf an Apotheken-Produkten und -Services:',
      bullet2: 'Merkliste mit Erinnerungen an <strong>regelmäßige Bestellungen und Medikamenteneinnahme</strong>',
      bullet3: 'Übersicht über alle rezeptfreien Bestellungen für die <strong>Steuerklärung oder Abrechnung mit der Krankenkasse</strong>',
    },
    bannerBlock: {
      nowInPharmacy: 'Jetzt in unserer Apotheke',
      vaccineTitle: 'Erste? Zweite? Booster? Wir impfen!',
      vaccineDescription: '<strong>Reservieren Sie einen Termin</strong> in Ihrer Apotheke vor Ort',
      vaccineLink: 'Impftermin buchen',
      makeAppointment: 'Jetzt online Termin vereinbaren',
      immunityTitle: 'Immunitäts-Nachweis Covid-19',
      immunityDescription: '<strong>Digital oder als Chipkarte</strong> jetzt in Ihrer Apotheke vor Ort',
      immunityLink: 'Mehr erfahren',
    },
    registerBlock: {
      registerNow: 'Jetzt registrieren und zukünftig noch schneller bestellen',
      setPassword: 'Legen Sie jetzt nur noch ein Passwort fest und Sie sind sofort startklar!',
      password: 'Passwort *',
      notice: 'Hinweis: ',
      passwordRules: 'Passwort muss mindestens 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Nummer enthalten',
      register: 'jetzt registrieren',
    },
  },
}

export default checkout
